<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-th-list" main="Mapa de Motoristas" sub="Visualizar disponibilidade de motoristas" />
        <div class="row justify-content-md-center">
            <div class="col-md-12">
                <FullCalendar :options='calendarOptions' class="mb-3"/>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12">
                <span class="legenda">Legenda:</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-2" v-for="motorista in motoristas" :key="motorista.id">
                <div class="btn-custom" :style="{ background: motorista.cor, color: motorista.fonte }">{{ motorista.nome }} ({{ motorista.capacidade }})</div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import ptBRLocale from '@fullcalendar/core/locales/pt-br'

export default {
    name: 'disponibilidade',
    components: { PageTitle, FullCalendar },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            motoristas: [],
            calendarOptions: {
                locale: ptBRLocale,
                plugins: [
                    dayGridPlugin
                ],
                headerToolbar: {
                    right: 'prev,next',
                    center: 'title',
                    left: ''
                },
                initialView: 'dayGridMonth',
                events: [],
                eventClick: this.handleEventClick
            },
        }
    },
    methods: {
        handleEventClick(clickInfo) {
            alert(clickInfo.event.title)
        },
        loadEvents(){
            const url = `${baseApiUrl}/backend/calendario.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='false'){
                    if(res.data['dados']!=='Não há dados disponíveis'){
                    this.calendarOptions.events = res.data.map(event => {
                        return { ...event, 
                                title: event.transporte, 
                                date: event.data,
                                url: 'http://routesys.effistecnologia.com/#/rastreio/' + event.transporte,
                                color: event.motorista_cor }
                    })
                }else{
                    this.calendarOptions.events = []
                }
                    
                }
            })
        },
        loadMotoristas(){
            const url = `${baseApiUrl}/backend/motoristas.php`
            axios.get(url).then(res => {
                this.motoristas = res.data
            })
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        this.loadEvents()
        this.loadMotoristas()
    }
}
</script>

<style>
.legenda {
    font-size: 0.8rem;
    font-style: italic;
}

.btn-custom {
    padding: 5px 5px 5px 5px;
    border: 0;
    text-align: center;
    font-size: 0.8rem;
    font-style: italic;
    width: 100%;
    height: 100%;
}
</style>